import { Stack } from 'expo-router';

import GoBackButton from '@/components/buttons/GoBackButton';
import Title from '@/components/Title';
import PlatformContainer from '@/components/web/PlatformContainer';
import { i18n } from '@/utils/i18n';

const ClaimNpoLayout = () => {
  return (
    <PlatformContainer contentCustomClassnames="flex">
      <Stack
        screenOptions={{
          headerShown: false,
          headerShadowVisible: false,
          headerBackVisible: false
        }}>
        <Stack.Screen
          name="index"
          options={{
            headerShown: true,
            headerShadowVisible: false,
            headerBackVisible: false,
            headerTitle: () => <Title label={i18n.t('mix.claim')} />,
            headerLeft: () => <GoBackButton />
          }}
        />
      </Stack>
    </PlatformContainer>
  );
};

export default ClaimNpoLayout;
